import * as Yup from 'yup';
export const rntSchema = Yup.object().shape({
  property: Yup.string()
    .min(3, 'Minimum 3 characters')
    .max(50, 'Maximum 50 characters')
    .required('Home name is required')
    .test('hasText', 'Home name cannot be only spaces', (value) => {
      return /\S/.test(value);
    }),
  address: Yup.string()
    .min(8, 'Minimum 8 characters')
    .required('Address is required')
    .test('hasText', 'Address cannot be only spaces', (value) => {
      return /\S/.test(value);
    }),
  street: Yup.string()
    .min(1, 'Minimum 1 character')
    .max(50, 'Maximum 50 characters')
    .required('Street is required')
    .test('hasText', 'Street cannot be only spaces', (value) => {
      return /\S/.test(value);
    }),
  uniteNo: Yup.string()
    .matches(/^[a-zA-Z0-9]*$/, 'Unit number can only contain letters & numbers')
    .min(1, 'Minimum 1 character')
    .max(50, 'Maximum 50 characters'),
  house: Yup.string()
    .matches(/^[a-zA-Z0-9]*$/, 'Street number can only contain letters & numbers')
    .min(1, 'Minimum 1 character')
    .max(50, 'Maximum 50 characters'),
  city: Yup.string()
    .min(3, 'Minimum 3 characters')
    .max(50, 'Maximum 50 characters')
    .required('City is required')
    .test('hasText', 'City cannot be only spaces', (value) => {
      return /\S/.test(value);
    }),
  province: Yup.string()
    .min(3, 'Minimum 3 characters')
    .max(50, 'Maximum 50 characters')
    .required('Province is required')
    .test('hasText', 'Province cannot be only spaces', (value) => {
      return /\S/.test(value);
    }),
  provinceCode: Yup.string()
    .matches(/^[a-zA-Z0-9 ]*$/, 'Province code can contain letters, numbers, and spaces')
    .min(2, 'Province code must be exactly 2 characters')
    .max(2, 'Province code must be exactly 2 characters')
    .required('Province code is required')
    .test('hasText', 'Province code cannot be only spaces', (value) => {
      return /\S/.test(value || '');
    }),

  country: Yup.string().required('Country is required'),
  postal: Yup.string()
    .matches(/^[a-zA-Z0-9 ]*$/, 'Postal code can contain letters, numbers, and spaces')
    .min(3, 'Postal code must be at least 3 characters long')
    .max(10, 'Postal code cannot exceed 10 characters')
    .required('Postal code is required')
    .test('hasText', 'Postal code cannot be only spaces', (value) => {
      return /\S/.test(value);
    }),
  rnt: Yup.string().matches(
    /^RNT\d{11}$/i,
    'TenantPay account number must start with RNT and be 11 digits'
  ),

  rent: Yup.string()
    .required('Rent Amount is required')
    .test(
      'is-greater-than-minimum',
      'Rent amount must be at least $100',
      (value) => parseFloat(value) >= 100
    )
    .test('has-max-two-decimals', 'Rent amount cannot have more than two decimal places', (value) =>
      /^\d+(\.\d{0,2})?$/.test(value)
    )
    .test(
      'is-less-than-max',
      'Rent amount must be less than or equal to 1000000',
      (value) => parseFloat(value) <= 1000000
    )
    .typeError('Rent Amount must be a valid number'),
  leaseStart: Yup.string().matches(
    /^\d{2} [A-Z][a-z]{2} \d{4}$/,
    'Invalid date format (DD MMM YYYY)'
  ),

  leaseEnd: Yup.string()
    .matches(/^\d{2} [A-Z][a-z]{2} \d{4}$/, 'Invalid date format (DD MMM YYYY)')
    .when('leaseStart', (leaseStart, schema) => {
      return leaseStart
        ? schema.test(
            'is-after-start',
            'Lease End Date must be after Lease Start Date',
            function (value) {
              if (!value) return true;
              const start = new Date(this.parent.leaseStart);
              const end = new Date(value);
              return end > start;
            }
          )
        : schema;
    }),

  dueDay: Yup.string(),
});
